import axios from 'axios'

/**
 * 获取所有人群包列表
 * @returns {Promise<Array>} 人群包列表
 */
export function fetchAllAudiencePackages() {
  return axios.get('/audience_packages')
    .then(response => {
      if (response.data.code === 0) {
        return response.data.data
      } else {
        console.error('获取人群包列表失败:', response.data.message)
        return []
      }
    })
    .catch(error => {
      console.error('获取人群包列表出错:', error)
      return []
    })
} 